import { consoleLogger } from '../constants/console-logger';
import { createMeasurementsStore, PerformanceLog } from '../utils/perf';
export class DeviceTelemetry {
    supportedTags = new Set();
    measurementsStore;
    telemetryLog;
    stopMonitoring = null;
    constructor() {
        this.telemetryLog = new PerformanceLog();
        this.measurementsStore = createMeasurementsStore();
        this.telemetryLog.registerHandler(this.measurementsStore.metricsHandler);
    }
    getMeasurementsStore() {
        return this.measurementsStore;
    }
    getPerformanceTags() {
        return this.supportedTags;
    }
    startMonitoring() {
        if (this.stopMonitoring) {
            consoleLogger.warn('Tried to start monitoring without stopping the previous session');
            this.stopMonitoring();
            this.stopMonitoring = null;
        }
        const stops = this.nativeStartMonitoring();
        const stopMonitoring = () => {
            stops();
            this.stopMonitoring = null;
        };
        this.stopMonitoring = stopMonitoring;
        return stopMonitoring;
    }
    getMemoryData(data, supportedTags) {
        const memory = data.filter((item) => item.tag === "MEMORY" /* PerfTag.memory */);
        const memoryUsage = memory.map((item) => ({ time: item.t.currentTime, value: item.value }));
        const memoryData = { usage: memoryUsage };
        if (supportedTags.has("MEMORY_LIMIT" /* PerfTag.memoryLimit */)) {
            const memoryLimit = data.find((item) => item.tag === "MEMORY_LIMIT" /* PerfTag.memoryLimit */);
            memoryData.memoryLimit = memoryLimit?.value;
        }
        if (supportedTags.has("USER_AGENT_SPECIFIC_MEMORY" /* PerfTag.userAgentSpecificMemory */)) {
            const userAgentSpecificMemory = data.find((item) => item.tag === "USER_AGENT_SPECIFIC_MEMORY" /* PerfTag.userAgentSpecificMemory */);
            memoryData.userAgentSpecificMemory = userAgentSpecificMemory?.value;
        }
        return memoryData;
    }
}
//# sourceMappingURL=device-telemetry.js.map